import { Controller } from "@hotwired/stimulus"

// Enforces a maximum number of checked genre boxes by disabling the rest once the max is reached.
export default class extends Controller {
  static targets = ["checkbox"]
  static values = { max: Number }

  connect() { this.toggle() }

  toggle() {
    const checked = this.checkboxTargets.filter((c) => c.checked).length
    this.checkboxTargets.forEach((c) => { c.disabled = !c.checked && checked >= this.maxValue })
  }
}
